import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    item: [],
    isLoading: false,
    firms: []
  },
  getters: {
    item: state => state.item,
    firms: state => state.firms,
    isLoading: state => state.isLoading
  },
  mutations: {
    setItem (state, payload) {
      state.item = payload
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setFirms (state, payload) {
      state.firms = payload
    }
  },
  actions: {
    async getItem ({ commit }, id) {
      commit('toggleLoading')
      const response = await new ApiService(`user_datas/${id}/financial_reports`).getResults()
      commit('toggleLoading')
      commit('setItem', response)
    }
  }
}
